export default "__VITE_PUBLIC_ASSET__cee6d0cc__"